export const QUOTATION = {
    plays: {
        0: {
            price: 0,
            discount: 0,
        },
        1000: {
            price: 4.95,
            discount: 0,
        },
        2000: {
            price: 8.95 * 1.1,
            discount: 1,
        },
        5000: {
            price: 22.95 * 1.1,
            discount: 2,
        },
        7500: {
            price: 32.95 * 1.1,
            discount: 4,
        },
        10000: {
            price: 41.95 * 1.1,
            discount: 8,
        },
        15000: {
            price: 59.95 * 1.1,
            discount: 14,
        },
        20000: {
            price: 75.95 * 1.1,
            discount: 23,
        },
        25000: {
            price: 89.95 * 1.1,
            discount: 34,
        },
        30000: {
            price: 101.95 * 1.1,
            discount: 47,
        },
        40000: {
            price: 127.95 * 1.1,
            discount: 70,
        },
        50000: {
            price: 149.95 * 1.1,
            discount: 98,
        },
        75000: {
            price: 209.95 * 1.1,
            discount: 161,
        },
        100000: {
            price: 259.95 * 1.1,
            discount: 235,
        },
        150000: {
            price: 329.95 * 1.1,
            discount: 413,
        },
        200000: {
            price: 399.95 * 1.1,
            discount: 590,
        },
        250000: {
            price: 449.95 * 1.1,
            discount: 798,
        },
    },
    monthlyListeners: {
        0: {
            price: 0,
            discount: 0,
        },
        1000: {
            price: 9.95,
            discount: 0,
        },
        5000: {
            price: 19.95 * 1.1,
            discount: 30,
        },
        7500: {
            price: 29.95 * 1.1,
            discount: 45,
        },
        10000: {
            price: 37.95 * 1.1,
            discount: 62,
        },
        15000: {
            price: 49.95 * 1.1,
            discount: 99,
        },
        20000: {
            price: 59.95 * 1.1,
            discount: 139,
        },
        25000: {
            price: 67.95 * 1.1,
            discount: 181,
        },
        30000: {
            price: 79.95 * 1.1,
            discount: 219,
        },
        40000: {
            price: 99.95 * 1.1,
            discount: 298,
        },
        50000: {
            price: 119.95 * 1.1,
            discount: 378,
        },
        75000: {
            price: 169.95 * 1.1,
            discount: 576,
        },
        100000: {
            price: 219.95 * 1.1,
            discount: 775,
        },
        150000: {
            price: 319.95 * 1.1,
            discount: 1173,
        },
        200000: {
            price: 399.95 * 1.1,
            discount: 1590,
        },
        250000: {
            price: 469.95 * 1.1,
            discount: 2018,
        },
    },
    saves: {
        0: {
            price: 0,
            discount: 0,
        },
        100: {
            price: 2.99,
            discount: 0,
        },
        150: {
            price: 3.98 * 1.1,
            discount: 0.5,
        },
        200: {
            price: 4.96 * 1.1,
            discount: 1,
        },
        250: {
            price: 5.95 * 1.1,
            discount: 1.53,
        },
        300: {
            price: 6.95 * 1.1,
            discount: 2,
        },
        350: {
            price: 7.95 * 1.1,
            discount: 2.51,
        },
        400: {
            price: 8.95 * 1.1,
            discount: 3.0,
        },
        450: {
            price: 9.95 * 1.1,
            discount: 3.51,
        },
        500: {
            price: 10.95 * 1.1,
            discount: 4,
        },
        600: {
            price: 12.75 * 1.1,
            discount: 5.19,
        },
        700: {
            price: 14.55 * 1.1,
            discount: 6.38,
        },
        800: {
            price: 16.35 * 1.1,
            discount: 7.57,
        },
        900: {
            price: 18.15 * 1.1,
            discount: 8.76,
        },
        1000: {
            price: 19.95 * 1.1,
            discount: 9.95,
        },
        1100: {
            price: 21.28 * 1.1,
            discount: 11.61,
        },
        1200: {
            price: 22.61 * 1.1,
            discount: 13.27,
        },
        1300: {
            price: 23.94 * 1.1,
            discount: 14.93,
        },
        1400: {
            price: 25.27 * 1.1,
            discount: 16.59,
        },
        1500: {
            price: 26.6 * 1.1,
            discount: 18.25,
        },
        1600: {
            price: 27.93 * 1.1,
            discount: 19.91,
        },
        1700: {
            price: 29.26 * 1.1,
            discount: 21.57,
        },
        1800: {
            price: 30.59 * 1.1,
            discount: 24.89,
        },
        1900: {
            price: 31.92 * 1.1,
            discount: 26.55,
        },
        2000: {
            price: 33.25 * 1.1,
            discount: 28.21,
        },
        2100: {
            price: 34.58 * 1.1,
            discount: 29.87,
        },
        2200: {
            price: 35.91 * 1.1,
            discount: 31.53,
        },
        2300: {
            price: 37.24 * 1.1,
            discount: 33.19,
        },
        2400: {
            price: 38.57 * 1.1,
            discount: 34.85,
        },
        2500: {
            price: 39.95 * 1.1,
            discount: 36.51,
        },
    },
    followers: {
        0: {
            price: 0,
            discount: 0,
        },
        100: {
            price: 7.95,
            discount: 0,
        },
        250: {
            price: 14.95 * 1.1,
            discount: 5,
        },
        500: {
            price: 19.95 * 1.1,
            discount: 20,
        },
        750: {
            price: 25.95 * 1.1,
            discount: 34,
        },
        1000: {
            price: 29.95 * 1.1,
            discount: 50,
        },
        // 1500: {
        //     price: 39.95 * 1.1,
        //     discount: 79,
        // },
        // 2000: {
        //     price: 46.95 * 1.1,
        //     discount: 113,
        // },
        // 2500: {
        //     price: 49.95 * 1.1,
        //     discount: 149,
        // },
        // 5000: {
        //     price: 79.95 * 1.1,
        //     discount: 318,
        // },
        // 7500: {
        //     price: 111.95 * 1.1,
        //     discount: 484,
        // },
        // 10000: {
        //     price: 139.95 * 1.1,
        //     discount: 655,
        // },
        // 15000: {
        //     price: 179.95 * 1.1,
        //     discount: 1013,
        // },
        // 20000: {
        //     price: 189.95 * 1.1,
        //     discount: 1400,
        // },
        // 25000: {
        //     price: 199.95 * 1.1,
        //     discount: 1788,
        // },
    },
};
const APP_CONFIG = {
    // app specific
    displayName: 'nextjs_template',
    QUERY_PAGE_SIZE: 10,
    QUERY_ALBUM_SIZE: 50,
    timerTick: 30, // seconds
    // generic config
    defaultAnimationDelay: 250, // ms
    defaultListEndReachedThreshold: 0.2,
    delayTextInputDebounce: 250,
    longAnimationDelay: 1000, // ms
    prefixReducer: 'nextjs_template',
    dateFormat: 'MM/dd/yyyy',
    defaultCurrency: {
        symbol: '$',
    },
    MAX_LISTENER: 75000,
    getOverMonthlyListenerMessage(): string {
        return `Due to high demand, Monthly Listener orders can currently not exceed ${this.MAX_LISTENER.toLocaleString(
            'en',
        )}. We are working on expanding our services further.`;
    },
    // env
    isDev: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
    isTesting: process.env.TESTING,
    // route
    privateRedirectRoute: '/login',
    publicRedirectRoute: '/',
    EMAIL_CONTACT: 'support@streamingpals.co',
    BASE_CURRENCY: process.env.BASE_CURRENCY || 'USD',
    PAYPAL_API_KEY: process.env.PAYPAL_API_KEY || '',
    PAYPAL_BUYER_COUNTRY: process.env.PAYPAL_BUYER_COUNTRY,
    PAYPAL_DISABLE_FUNDING: process.env.PAYPAL_DISABLE_FUNDING,
    SECRET_KEY_HMAC: process.env.SECRET_KEY_HMAC || '',
    GEOLOCATION_PLUGIN_URL: process.env.GEOLOCATION_PLUGIN_URL || '',
    CURRENCY_CONVERT_API_KEY: process.env.CURRENCY_CONVERT_API_KEY,
    CURRENCY_CONVERT_URL: process.env.CURRENCY_CONVERT_URL,
    EVENT_CONCONVERSION: process.env.EVENT_CONCONVERSION || 'purchase',
    GA_CATEGORY: process.env.NEXT_PUBLIC_GA_CATEGORY || 'ga_purchase',
    SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    /*eslint-disable */
    regexIsUrl:
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    /* eslint-enable */
    STREAMING_PAL: {
        defaultPercentStart: 10,
        STATUS_RATE_LIMIT: 429,
        regexUrl:
            /(http(?:s?):\/\/)?(?:www\.)?(open.spotify.com\/artist\/)([a-zA-Z0-9]+)?(?:\?)?([\d]+)?/,
        API_KEY: [
            {
                client_id: '9fc9478910224791830e87212a84d233',
                client_secret: '801b43cbdf21424cbe2b45ceb0e9b6e3',
            },
            {
                client_id: '2660ec4e74b849e5864ab803a0d45b25',
                client_secret: 'f76ab7143f394c908f3b748039fb942a',
            },
        ],
        DEFAULT_VALUE: {
            followers: {
                price: 7.95,
                quantity: 100,
                discount: 0,
                start: 1,
                // price: 0,
                // quantity: 0,
                // discount: 0,
                // start: 0,
            },
            saves: {
                price: 6.55,
                quantity: 250,
                discount:1.53,
                start: 4,
                // price: 0,
                // quantity: 0,
                // discount: 0,
                // start: 0,
                // slide_range: {
                //     min: [0, 100],
                //     '10%': [100, 50],
                //     '20%': [500, 100],
                //     max: [2500],
                // },
            },
            plays: {
                // price: 0,
                // quantity: 0,
                // discount: 0,
                // start: 0,
                price: 4.95,
                quantity: 1000,
                discount: 0,
                start: 1,
            },
            monthlyListeners: {
                // price: 0,
                // quantity: 0,
                // discount: 0,
                // start: 0,
                price: 9.95,
                quantity: 1000,
                discount: 0,
                start: 1,
            },
        },
    },
    STREAMINGPAL_PRICES: {
        follower: 0.0799,
        save: 0.0299,
        monthlyListener: 0.00999,
        play: 0.001,
    },
    IPAY88: {
        PAYMENT_LINK: process.env.IPAY88_PAYMENT_LINK,
        MERCHANT_CODE: process.env.IPAY88_MERCHANT_CODE,
        MERCHANT_KEY: process.env.IPAY88_MERCHANT_KEY,
        PAYMENT_ID: process.env.IPAY88_PAYMENT_ID,
        CURRENCY: process.env.IPAY88_CURRENCY,
        SIGNATURE_TYPE: process.env.IPAY88_SIGNATURE_TYPE,
        // BACKEND_URL: `${process.env.NEXT_PUBLIC_API_BASE_URL}v1/complete-order`,
        BACKEND_URL: `${process.env.NEXT_PUBLIC_API_BASE_URL}order/ipay88_complete`,
        RESPONSE_URL: `${process.env.NEXT_PUBLIC_SITE_URL}/complete-order`,
    },
    DOMAIN_SITE: 'streamingpals',
};

export const GTM_ID = 'GTM-MWLD7JT';
export const ORDER_MAX_AMOUNT = 350;

export const LANDING_PAGE_URL = process.env.NEXT_PUBLIC_LANDING_URL;

export const MAX_AMOUNT_DEFAULT = 350;

export default APP_CONFIG;
